import { Button, Flex, Text } from "@gravity-ui/uikit";
import { StoreBadge } from "src/components";

import { StoreOffersGroup, StoreSummary } from "../../../../utils";
import { useProductStorePickerTranslate } from "./hooks";

interface ProductStorePickerProps {
  stores: StoreSummary[];
  variantStores: StoreOffersGroup[];
  value: string | null;
  onChange: (store: string | null) => void;
}

export const ProductStorePicker = ({
  stores,
  variantStores,
  value,
  onChange,
}: ProductStorePickerProps) => {
  const translations = useProductStorePickerTranslate();

  if (stores.length < 2) return null;

  const priceByStore = new Map(
    variantStores.map((group) => [group.store, group]),
  );

  const cheapest = variantStores[0];

  return (
    <Flex direction="column" gap="2">
      <Text variant="subheader-2" color="secondary">
        {translations.store}
      </Text>

      <Flex gap="2" wrap>
        <Button
          size="m"
          pin="round-round"
          view={value === null ? "action" : "outlined"}
          onClick={() => onChange(null)}
        >
          {cheapest
            ? translations.all_from(cheapest.minPrice, cheapest.currency)
            : translations.all}
        </Button>

        {stores.map(({ store }) => {
          const group = priceByStore.get(store);

          return (
            <Button
              key={store}
              size="m"
              pin="round-round"
              disabled={!group}
              view={value === store ? "action" : "outlined"}
              onClick={() => onChange(store)}
            >
              <Flex gap="2" alignItems="center">
                <StoreBadge store={store} />
                {group
                  ? `${store} · ${group.minPrice} ${group.currency}`
                  : store}
              </Flex>
            </Button>
          );
        })}
      </Flex>
    </Flex>
  );
};
